interface Props {
  activeColor: string;
  bgColor?: string;
}

const RejectLeadsIcon = ({ activeColor, bgColor }: Props) => {
  const fillColor = activeColor ? activeColor : "#2E8B57";
  const bgFillColor = bgColor ? bgColor : "#F1F3F5";
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill={bgFillColor} />

      <circle cx="20" cy="18" r="4" stroke="#6C757D" strokeWidth="2" />

      <path
        d="M12 32c0-4 3.5-7 8-7s8 3 8 7"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
      />

      <path
        d="M30 16 L36 22 M36 16 L30 22"
        stroke="#6C757D"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default RejectLeadsIcon;
